import React from 'react';
import { FileQuestion, Layers, GitBranch, Database, FlaskConical, Quote } from 'lucide-react';

const CARDS = [
  {
    icon: FileQuestion,
    title: '5,000 PDFs, none named usefully',
    body:
      'Every browser download saves as ssrn-id3942817.pdf, 1234.5678v2.pdf, or paper.pdf. After two years of literature review, your Downloads folder has 5,000 PDFs and you cannot tell what is what without opening each one. Search in Spotlight finds the body text but not the title.',
  },
  {
    icon: Layers,
    title: 'Conference papers, preprints, and supplemental data piled together',
    body:
      'A single project has the NeurIPS 2023 paper, the arXiv preprint that became NeurIPS 2023, the camera-ready version, four supplemental PDFs, the slide deck, and a CSV of the experimental data. They all live in the same folder named "transformers_stuff". The version that matters is anyone\'s guess.',
  },
  {
    icon: GitBranch,
    title: 'Version control on draft chapters',
    body:
      'thesis_v2.docx, thesis_v3_FINAL.docx, thesis_v3_FINAL_REAL.docx, thesis_v3_FINAL_REAL_after_advisor.docx. Plus the LaTeX builds, the Overleaf zip backups, the figures folder revision, and a coauthor sending feedback by email. Reconstructing what version was current on April 14th takes an hour of detective work.',
  },
  {
    icon: Database,
    title: 'Supplemental data lost from the paper',
    body:
      'A reviewer asks for the supplemental data tables from a paper you submitted 14 months ago. The paper lives in Zotero, the figures live in OneDrive, the raw CSVs live in a local "scratch" folder, and the analysis notebook is on a colleague\'s GitHub. Pulling them together is a half-day excavation.',
  },
  {
    icon: FlaskConical,
    title: 'Project folders that drift over time',
    body:
      'A new project starts clean: dedicated folder, subfolders for literature, drafts, data, and figures. Six months in, downloads land in Downloads, draft figures land on the Desktop, the literature subfolder has six unrelated papers a collaborator emailed. The project has multiplied across three locations.',
  },
  {
    icon: Quote,
    title: 'Citation export is a separate, manual step',
    body:
      'You read a paper, decide to cite it, dig up the BibTeX from Google Scholar or the publisher page, paste it into your .bib file, fix the citation key. Across a 200-paper lit review chapter that is hours of busywork that fragments the reading flow.',
  },
];

const PainPoints = () => {
  return (
    <section id="problem" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          The research file management problem
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Six patterns we hear from PhD students, postdocs, and lab PIs running multi-project
          research with Zotero and a stack of PDF chaos.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {CARDS.map((card, i) => {
          const Icon = card.icon;
          return (
            <div key={i} className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6">
              <div className="w-10 h-10 rounded-full bg-sortio-secondary/15 border border-sortio-secondary/30 flex items-center justify-center mb-4">
                <Icon className="text-sortio-secondary" size={18} />
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-3">{card.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{card.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default PainPoints;
